import { useState, useEffect, useRef, useMemo } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import {
  FormGroup,
  FormLabel,
  FormControl,
  Row,
  Col,
  Button,
  Form,
  // OverlayTrigger,
  // Tooltip,
} from "react-bootstrap";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { toast } from "react-toastify";
import { debounce } from "lodash";

import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import {
  calculateAge,
  formatCalendarDate,
  formatPhoneNumber,
  getFieldClass,
} from "../../../Utils/helper";
import CreateNewClientHeader from "../CreateClientHeader";
import SelectStateModal from "../../TreatmentPage/modals/state-modal/SelectStateModal";
import { api_without_cancellation } from "../../../api/api";
import useSourceSearch from "../new-client/hooks/useSourceSearch";
import SourceLinking from "../new-client/source-linking";
import AutoCompleteSearch from "../../Insurance/AutoCompleteSearch";
import ContactPanelForEditPopups from "../../TreatmentPage/components/ContactPanelForEditPopups";
import DateInput from "../../common/DateInput";
// import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";

const formatCaseClientAddress = (address) =>
  [
    address?.address1,
    address?.address2,
    address?.city,
    [address?.state, address?.post_code].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(", ");

const NewClientForExistingCase = ({
  data,
  onChange,
  // isEmailValid,
  setEmailValid,
  // isPhoneValid,
  setPhoneValid,
  loading,
  setLoading,
  sourceTypes,
  sourceCategories,
  caseSources,
  _insuranceTypes,
  insuranceNewTypes,
  state,
  homeStateClient,
  setHomeStateClient,
  _homeStateSource,
  setHomeStateSource,
  pendingLeadData,
  pendingLeadAvailable,
  storedLeadData,
  subActiveTab,
  setStoreLink,
  setLoadingSave,
  setShowPopup,
  setShowNormal,
  fieldStates,
  loadingSave,
}) => {
  // const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";

  // const [loading, isLoading] = useState(false);
  // const [state, setState] = useState([]);

  const [currentTab, setCurrentTab] = useState(0); // 0, 1, 2, 3, 4
  // const [_caseTypes, setCaseTypes] = useState([]);
  // const [insuranceTypes, setInsuranceTypes] = useState([]);
  // const [_reportingagencyTypes, setReportingagencyTypes] = useState([]);
  // const [_fieldStates, setFieldStates] = useState({});

  // source fields start here
  // const [sourceTypes, setSourceTypes] = useState([]);
  // const [sourceCategories, setSourceCategories] = useState([]);
  // const [caseSources, setCaseSources] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSourceName, setSelectedSourceName] = useState("");
  const [disabledCategory, setDisabledCategory] = useState(true);
  const [disabledSourceName, setDisabledSourceName] = useState(true);
  //source fields end here

  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [caseClientAddresses, setCaseClientAddresses] = useState([]);
  const [selectedCaseAddress, setSelectedCaseAddress] = useState(null);
  const [addressDropdownOpen, setAddressDropdownOpen] = useState(false);
  const [addressesLoading, setAddressesLoading] = useState(false);
  const addressDropdownRef = useRef(null);

  // const selectRef = useRef(null);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // const phoneRegex = /^(?:\d{10}|\(\d{3}\) \d{3}-\d{4})$/;

  const [showStatesModalClientThird, setShowStatesModalClientThird] = useState(false);
  const [showStatesModalSourceThird, setShowStatesModalSourceThird] = useState(false);

  // Handle email input change
  const handleClientEmailChange = (e) => {
    const email = e.target.value;
    onChange("client_email", email);

    if (email !== "") {
      setEmailValid((prevValid) => ({
        ...prevValid,
        client_email: emailRegex.test(email),
      }));
    } else {
      setEmailValid((prevValid) => ({
        ...prevValid,
        client_email: true, // Set as valid when empty
      }));
    }
  };

  const handleClientPhoneChange = (e) => {
    const phone = e.target.value.replace(/\D/g, "");
    let formattedValue = "";
    if (phone.length > 0) {
      formattedValue += `(${phone.slice(0, 3)}`;
    }
    if (phone.length > 3) {
      formattedValue += `) ${phone.slice(3, 6)}`;
    }
    if (phone.length > 6) {
      formattedValue += `-${phone.slice(6, 10)}`;
    }

    e.target.value = formattedValue;
    onChange("client_phone", formattedValue);

    if (phone !== "") {
      setPhoneValid((prevValid) => ({
        ...prevValid,
        client_phone: true,
      }));
    } else {
      setPhoneValid((prevValid) => ({
        ...prevValid,
        client_phone: true, // Set as valid when empty
      }));
    }
  };

  const handleNext = () => {
    if (currentTab < 3) {
      setCurrentTab(currentTab + 1);
    } else {
      setCurrentTab(0);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleNext();
    }
  };

  // const colourStyles = {
  //   container: (base) => ({
  //     ...base,
  //     marginTop: "5px",
  //     height: "40px",
  //     marginRight: "5px",
  //   }),
  //   control: (styles, { isFocused }) => ({
  //     ...styles,
  //     backgroundColor: "white",
  //     border: isFocused ? "1px solid red" : "1px solid #ff8f8f",
  //     boxShadow: isFocused ? "0 0 0 2px rgba(25, 57, 95, 0.2)" : "none",
  //     "&:hover": {
  //       border: "1px solid red",
  //     },
  //     // width: "104.8%",
  //   }),
  //   valueContainer: (styles) => ({
  //     ...styles,
  //     padding: "0 5px",
  //   }),
  //   menuList: (provided) => ({
  //     ...provided,
  //     maxHeight: "calc(100vh - 350px)", // Further restrict to fit within viewport
  //   }),
  //   option: (styles, { isFocused, isSelected }) => ({
  //     ...styles,
  //     backgroundColor: isSelected ? "#19395f" : isFocused ? "#e0e0e0" : "white",
  //     color: isSelected ? "white" : "#4a5568",
  //     fontWeight: isSelected ? "bold" : "normal",
  //     "&:hover": {
  //       backgroundColor: "#25568f",
  //       color: "white",
  //     },
  //   }),
  //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  // };

  // const handleChange = (selected) => {
  //   setSelectedOption(selected); // Set the selected option
  //   setSearch(""); // Reset the search field
  //   setSearchResults([]); // Clear the search results
  //   selectRef.current.blur();
  // };

  // const handleInputChange = (newValue) => {
  //   setSearch(newValue);
  // };

  const fetchSearchData = async (searchTerm) => {
    if (searchTerm.trim().length < 3) {
      setSearchResults([]); // Clear results if search term is too short
      return;
    }
    try {
      const response = await api_without_cancellation.post("/api/search/cases/", {
        name: searchTerm,
      });

      if (response.data && response.data.data) {
        setSearchResults(
          response.data.data?.map((result) => {
            const age = result?.for_client?.birthday
              ? calculateAge(result.for_client.birthday)
              : "";
            return {
              value: result.id,
              label: (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span>
                    {result?.for_client?.last_name || "N/A"}
                    {result?.for_client?.middle_name
                      ? `, ${result.for_client.middle_name} ${result.for_client.first_name}`
                      : `, ${result.for_client?.first_name || "N/A"}`}
                    ,{" "}
                  </span>
                  <img
                    src={birthdayIcon}
                    alt="Birthday"
                    style={{ width: "16px", height: "16px" }}
                  />
                  <span>
                    {formatCalendarDate(result?.for_client?.birthday || "N/A")}
                    {" , "}
                    {age ? `${age} years` : "0 years"},{" "}
                  </span>
                  {result?.case_type?.casetype_icon && (
                    <img
                      src={result?.case_type?.casetype_icon}
                      alt="Case"
                      style={{ width: "16px", height: "16px" }}
                    />
                  )}
                  {result?.case_type?.name || "N/A"}
                  {" , "}
                  <img
                    src={incidentIcon}
                    alt="Incident"
                    style={{ width: "16px", height: "16px" }}
                  />
                  {formatCalendarDate(result?.incident_date) || "N/A"}
                </div>
              ),

              searchText: `${result?.for_client?.last_name || "N/A"} ${result?.for_client?.first_name || "N/A"} ${result?.for_client?.birthday || "N/A"} ${result?.case_type?.name || "N/A"} ${formatCalendarDate(result?.incident_date) || "N/A"}`,
              ...result,
            };
          })
        );
      } else {
        console.error("Unexpected response structure:", response.data);
        setSearchResults([]); // Clear results if response structure is unexpected
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSearchResults([]); // Clear results on error
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search) fetchSearchData(search);
    }, 400); // Debounce input

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentTab]);

  useEffect(() => {
    onChange("case_id", selectedOption?.id || "");
    onChange("client_incident_date", selectedOption?.incident_date || "");
    onChange("client_case_type", selectedOption?.case_type);

    setCaseClientAddresses([]);
    setSelectedCaseAddress(null);
    setAddressDropdownOpen(false);

    if (!selectedOption?.id) {
      setAddressesLoading(false);
      return undefined;
    }

    let ignoreResponse = false;

    const fetchCaseClientAddresses = async () => {
      setAddressesLoading(true);

      try {
        const response = await api_without_cancellation.get(
          `/api/case-client-addresses/${selectedOption.id}`
        );

        if (!ignoreResponse) {
          setCaseClientAddresses(
            Array.isArray(response.data?.addresses) ? response.data.addresses : []
          );
        }
      } catch (error) {
        if (!ignoreResponse) {
          console.error("Error fetching case client addresses:", error);
          setCaseClientAddresses([]);
        }
      } finally {
        if (!ignoreResponse) {
          setAddressesLoading(false);
        }
      }
    };

    fetchCaseClientAddresses();

    return () => {
      ignoreResponse = true;
    };
  }, [selectedOption]);

  const handleCaseAddressSelect = (address) => {
    const matchingState = Array.isArray(state)
      ? state.find((stateOption) => stateOption.StateAbr === address.state)
      : null;

    setSelectedCaseAddress(address);
    setAddressDropdownOpen(false);
    onChange("client_address1", address.address1 || "");
    onChange("client_address2", address.address2 || "");
    onChange("client_city", address.city || "");
    onChange("client_state", address.state || "");
    onChange("client_zip", address.post_code || "");
    setHomeStateClient(address.state ? matchingState || { StateAbr: address.state } : null);
  };

  // useEffect(() => {
  //   const fetchFieldSettings = async () => {
  //     try {
  //       isLoading(true);

  //       const response = await fetch(`${origin}/api/firm_enabled_fields/`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: getToken(),
  //         },
  //       });
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch field settings");
  //       }
  //       const data = await response.json();

  //       setFieldStates(data.firm_field_settings.enabled_fields);

  //       const { source_types, source_categories, case_sources } = data;
  //       setSourceTypes(source_types);
  //       setSourceCategories(source_categories);
  //       setCaseSources(case_sources);
  //     } catch (error) {
  //       isLoading(false);
  //       console.error("Error fetching field settings:", error);
  //     }
  //   };

  //   const fetchCaseTypes = async () => {
  //     try {
  //       isLoading(true);
  //       const response = await fetch(`${origin}/api/get_case_types/`);
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch case types");
  //       }
  //       const data = await response.json();

  //       setCaseTypes(data.case_type_categories);
  //       setInsuranceTypes(data.insurance_companies);
  //       setReportingagencyTypes(data.reporting_agencies);
  //       setState(data.states);
  //       isLoading(false);
  //     } catch (error) {
  //       isLoading(false);
  //       console.error("Error fetching case types:", error);
  //     }
  //   };

  //   fetchCaseTypes();
  //   fetchFieldSettings();
  // }, [origin]);

  const handleTypeChange = (e) => {
    const selectedTypeValue = parseInt(e.target.value, 10); // Ensure it's an integer
    setSelectedType(selectedTypeValue);
    setSelectedCategory("");
    setSelectedSourceName("");
    setDisabledCategory(selectedTypeValue === 0);
    setDisabledSourceName(true);
    onChange("source_type", selectedTypeValue);

    if (selectedTypeValue === 0) {
      onChange("source_category", 0);
      onChange("source_name", 0);
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryValue = parseInt(e.target.value, 10);
    setSelectedCategory(selectedCategoryValue);
    setSelectedSourceName("");
    setDisabledSourceName(selectedCategoryValue === 0);
    onChange("source_category", selectedCategoryValue);

    if (selectedCategoryValue === 0) {
      onChange("source_name", 0);
    }
  };

  // Filter source categories based on selected type
  const filteredCategories = sourceCategories.filter(
    (category) => category.source_type === selectedType
  );

  // Filter case sources based on selected type and category
  const filteredCaseSources = caseSources.filter(
    (source) => source.source_type === selectedType && source.source_category === selectedCategory
  );

  const handleSourceNameChange = (e) => {
    setSelectedSourceName(parseInt(e.target.value, 10));

    const selectedCategoryValue = parseInt(e.target.value, 10);
    onChange("source_name", selectedCategoryValue);
  };
  const [activeTab, setActiveTab] = useState("existing-case");
  const [clientNameValidationAttempted, setClientNameValidationAttempted] = useState(false);
  // const sidebarItems = [
  //   { id: "existing-case", name: "Existing Case" },
  //   { id: "client", name: "Client" },
  //   { id: "source", name: "Source" },
  //   { id: "notes", name: "Notes" },
  // ];
  const handleTabChange = (id) => {
    setActiveTab(id);
  };
  const sidebarItems = useMemo(() => {
    const tabs = [];
    //

    tabs.push({
      id: "existing-case",
      label: "Existing Case",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("existing-case"),
      leftHand: false,
    });

    tabs.push({
      id: "client",
      label: "Client",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("client"),
      leftHand: false,
    });

    tabs.push({
      id: "source",
      label: "Source",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("source"),
      leftHand: false,
    });

    tabs.push({
      id: "notes",
      label: "Notes",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("notes"),
      leftHand: false,
    });

    return tabs;
  }, []);
  const [sourceNameOpen, setSourceNameOpen] = useState(false);
  const [sourceCategoryOpen, setSourceCategoryOpen] = useState(false);
  const [sourceTypeOpen, setSourceTypeOpen] = useState(false);

  const [insuranceTypeOpen, setInsuranceTypeOpen] = useState(false);
  // const [insuranceCompanyOpen, setInsuranceCompanyOpen] = useState(false);

  const clientSearchRef = useRef(null);
  const clientSearchInputRef = useRef(null); // ← add this

  const [clientSearchOpen, setClientSearchOpen] = useState(false);
  useEffect(() => {
    function handleClickOutside(event) {
      if (clientSearchRef.current && !clientSearchRef.current.contains(event.target)) {
        setClientSearchOpen(false);
      }
      if (addressDropdownRef.current && !addressDropdownRef.current.contains(event.target)) {
        setAddressDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [linkedSources, setLinkedSources] = useState([]);
  const sourceLinkingRef = useRef(null);
  const [search2, setSearch2] = useState("");

  const { results: searchedSources, isLoading: sourceSearchLoading } = useSourceSearch(search2);
  const [pendingSourceStateKey, setPendingSourceStateKey] = useState(null);
  const [linkModal, setLinkModal] = useState(false);
  const handleSave = async () => {
    const storedLeadDataNew = JSON.parse(localStorage.getItem("LeadData"));

    if (!data.case_id || data.case_id === 0) {
      toast.error("Please select a Case before saving");
      return;
    }

    const missingFirstName = !data.client_first_name?.trim();
    const missingLastName = !data.client_last_name?.trim();

    if (missingFirstName || missingLastName) {
      setClientNameValidationAttempted(true);
      setActiveTab("client");
      toast.error(
        missingFirstName && missingLastName
          ? "Client first name and last name are required"
          : missingFirstName
            ? "Client first name is required"
            : "Client last name is required"
      );
      return;
    }

    // const dataToSave = formData[tabKey];
    const dataToSave = {
      ...data,
      case_sources: [...linkedSources],
      ...(storedLeadDataNew &&
      subActiveTab === storedLeadDataNew.LeadActiveTab &&
      pendingLeadAvailable
        ? { lead_id: pendingLeadData.id }
        : { lead_id: null }),
    };

    const filteredData = Object.fromEntries(
      Object.entries(dataToSave).filter(([key]) => {
        const fieldMappings = {
          jurisdiction: ["intake_jurisdiction"],
          venue_county: ["intake_venue_county"],
        };

        for (const [fieldKey, formFields] of Object.entries(fieldMappings)) {
          if (formFields.includes(key)) {
            return fieldStates[fieldKey] !== false; // Include if enabled in fieldStates
          }
        }

        // Include all other fields by default
        return true;
      })
    );
    try {
      setLoadingSave(true);

      const response = await api_without_cancellation.post(
        "/api/new_client_existing_case/",
        filteredData
      );
      if (response.status === 200 || response.status === 201) {
        const result = await response.data;
        if (storedLeadData && subActiveTab === storedLeadData.LeadActiveTab) {
          localStorage.removeItem("LeadData");
        }
        setLinkedSources([]);
        setStoreLink(result);
        setLoadingSave(false);
        setShowPopup(true);
        setShowNormal(false);
      } else {
        console.error("Failed to save data:", response.statusText);
        setLoadingSave(false);
        if (response?.status === 402) {
          toast.error("Free accounts cannot add new clients");
          return;
        } else {
          toast.error("Failed to save the data");
        }
      }
    } catch (error) {
      console.error("Error during save operation:", error);
    } finally {
      setLoadingSave(false);
    }
  };

  let search_input = "";
  const [searchedInsurances, setSerachInsurances] = useState([]);
  const [searchedAjusters, setSerachAdjusters] = useState([]);

  const fetchData = async (search, type) => {
    try {
      const params = { query: search };
      let response;

      if (type === "company") {
        response = await api_without_cancellation.get("/api/insurances/search/", { params });
      } else if (type === "adjuster") {
        response = await api_without_cancellation.get(
          "/api/general/search_filter_adjuster_directoires/",
          {
            params,
          }
        );
      }

      const data = response.data.data; // no frontend filtering

      if (type === "company") {
        setSerachInsurances(data);
        setSerachAdjusters([]);
      }
      if (type === "adjuster") {
        setSerachAdjusters(data);
        setSerachInsurances([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const debouncedFetch = useMemo(
    () => debounce((search, type) => fetchData(search, type), 400),
    []
  );
  const [companySearchInput, setCompanySearchInput] = useState("");
  const [adjusterSearchInput, setAdjusterSearchInput] = useState("");
  const [, setSelectedCompany] = useState(null);
  const [, setSelectedAdjuster] = useState(null);

  const handleSearchInsurances = (event, type) => {
    search_input = event.target.value;
    if (search_input === "") {
      setSerachInsurances([]);
      setSerachAdjusters([]);
    } else if (search_input.length >= 2) {
      debouncedFetch(search_input, type);
    } else {
      setSerachInsurances([]);
      setSerachAdjusters([]);
    }
  };

  const handleSelectedInsuranceTabs = (type, id) => {
    if (type === "company") {
      const a = searchedInsurances?.find((a) => a?.id === id);
      setSelectedCompany(a);
      onChange("client_insurance_company_id", a?.company_id);
      setCompanySearchInput(a?.company_name || "");
      onChange("client_company_name", a.company_name);
      onChange("client_company_address1", a.address1);
      onChange("client_company_address2", a.address2);
      onChange("client_company_city", a.city);
      onChange("client_company_state", a.state);
      onChange("client_company_zip", a.zip);
      onChange("client_company_phone", formatPhoneNumber(a.phone));
      onChange("client_company_extension_field", a?.extension || "");
      onChange("client_company_fax", formatPhoneNumber(a.fax));
      onChange("client_company_email", a.email);
      onChange("client_company_website", a.website);
    }
    if (type === "adjuster") {
      onChange("client_insurance_adjuster_id", id);
      const a = searchedAjusters?.find((a) => a?.id === id);
      setSelectedAdjuster(a);
      const name = `${a?.first_name} ${a?.last_name}`;
      setAdjusterSearchInput(name || "");
      onChange("client_adjuster_first_name", a.first_name);
      onChange("client_adjuster_last_name", a.last_name);
      onChange("client_adjuster_address1", a.address1);
      onChange("client_adjuster_address2", a.address2);
      onChange("client_adjuster_city", a.city);
      onChange("client_adjuster_state", a.state);
      onChange("client_adjuster_zip", a.zip);
      onChange("client_adjuster_phone", formatPhoneNumber(a.phone));
      onChange("client_adjuster_extension_field", a?.extension || "");
      onChange("client_adjuster_fax", formatPhoneNumber(a.fax));
      onChange("client_adjuster_email", a.email);
      onChange("client_adjuster_website", a.website);
    }
    setSerachAdjusters([]);
    setSerachInsurances([]);
  };

  const [insuranceNewCompanyState, setInsuranceNewCompanyState] = useState(false);
  const handleStateShow = () => setInsuranceNewCompanyState(!insuranceNewCompanyState);

  const [adjusterState, setAdjusterState] = useState(false);
  const handleAdjusterStateShow = () => setAdjusterState(!adjusterState);
  const InsuranceButtons = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];

  const insuranceTypeRef = useRef(null);
  const companySearchRef = useRef(null);
  const adjusterSearchRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (insuranceTypeRef.current && !insuranceTypeRef.current.contains(e.target)) {
        setInsuranceTypeOpen(false);
      }
      if (companySearchRef.current && !companySearchRef.current.contains(e.target)) {
        setSerachInsurances([]);
      }
      if (adjusterSearchRef.current && !adjusterSearchRef.current.contains(e.target)) {
        setSerachAdjusters([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handlePhoneChange = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_company_phone", formattedValue);
  };

  const handleFaxChange = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_company_fax", formattedValue);
  };
  const handlePhoneChangeAdj = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_adjuster_phone", formattedValue);
  };

  const handleFaxChangeAdj = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_adjuster_fax", formattedValue);
  };

  return (
    <>
      <CreateNewClientHeader
        sidebarItems={sidebarItems}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
      />

      {activeTab === "existing-case" &&
        (loading ? (
          <PulseLoader
            loading={setLoading}
            size={16}
            aria-label="Loading Spinner"
            data-testid="loader"
            color="#19395F"
            style={{
              display: "flex",
              flexDirection: "row",
              height: "calc(100vh-119px)",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          />
        ) : (
          <>
            {/* <Select
              ref={selectRef}
              value={null}
              onChange={handleChange}
              onInputChange={handleInputChange}
              options={searchResults}
              styles={colourStyles}
              isSearchable
              placeholder="Type the case name in to identify the existing case and begin their new client."
              menuPortalTarget={document.body}
              filterOption={(option, input) => {
                const text = `${option.data.for_client?.last_name || "N/A"} ${option.data.for_client?.first_name || "N/A"} ${option.data.for_client?.birthday || "N/A"} ${option.data.case_type?.name || "N/A"} ${formatCalendarDate(option.data.incident_date) || "N/A"}`;
                return text.toLowerCase().includes(input.toLowerCase());
              }}
            /> */}

            <div
              ref={clientSearchRef}
              style={{ position: "relative" }}
              className="pe-0 m-t-5 custom-select-new-provider"
            >
              <input
                type="text"
                ref={clientSearchInputRef}
                className="form-control p-0 p-l-5 rounded-0"
                style={{ height: "25px" }}
                placeholder="Type the case name in to identify the existing case and begin their new client."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setClientSearchOpen(true);
                }}
                onFocus={() => {
                  if (search.trim().length >= 3 && searchResults.length > 0) {
                    setClientSearchOpen(true);
                  }
                }}
              />

              {clientSearchOpen && searchResults.length > 0 && (
                <div
                  className="dropdown-menu p-0 mt-0"
                  style={{
                    display: "block",
                    width: "100%",
                    border: "1px solid #ced4da",
                    maxHeight: "500px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    zIndex: 9999,
                  }}
                >
                  {searchResults.map((result) => (
                    <div
                      key={result.value}
                      className="dropdown-option height-25 d-flex align-items-center"
                      style={{ cursor: "pointer", paddingLeft: "5px", fontWeight: "600" }}
                      // onMouseDown={(e) => {
                      //   e.preventDefault();
                      //   setSelectedOption(result);
                      //   setClientSearchOpen(false);
                      // }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setSelectedOption(result);
                        setClientSearchOpen(false);
                        clientSearchInputRef.current?.blur(); // ← add this
                      }}
                    >
                      {result.label}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {selectedOption && (
              <Col
                md="6"
                className="tabclient"
                style={{
                  margin: "5px auto",
                  paddingLeft: "0px",
                  marginLeft: "0px",
                }}
              >
                <FormGroup as={Row} className="mx-auto m-b-5">
                  <FormLabel
                    column
                    sm="2"
                    className="p-0 height-25 d-flex align-items-center"
                    style={{
                      color: "var(--primary-25)",
                      fontWeight: "600",
                    }}
                  >
                    Case Type: <span className="required-aes">*</span>
                  </FormLabel>
                  <Col sm="2" className="p-0 height-25">
                    <FormLabel
                      className="mb-0 height-25 d-flex align-items-center"
                      style={{ fontWeight: "bold" }}
                    >
                      <span className="ic ic-15 d-flex align-items-center m-r-5 justify-content-center">
                        <img src={selectedOption.case_type?.casetype_icon} />
                      </span>
                      {selectedOption.case_type?.name || "N/A"}
                    </FormLabel>
                  </Col>

                  <FormLabel
                    style={{
                      color: "var(--primary-25)",
                      fontWeight: "600",
                    }}
                    column
                    sm="2"
                    className="p-0 height-25 d-flex align-items-center"
                  >
                    Incident Date: <span className="required-aes">*</span>
                  </FormLabel>
                  <Col sm="2" className="p-0 height-25 d-flex align-items-center">
                    <FormLabel
                      className="mb-0 height-25 d-flex align-items-center"
                      style={{ fontWeight: "bold" }}
                    >
                      <span className="ic ic-15 d-flex align-items-center m-r-5 justify-content-center">
                        <img src={incidentIcon} />
                      </span>
                      {formatCalendarDate(selectedOption.incident_date) || "N/A"}
                    </FormLabel>
                  </Col>
                </FormGroup>
                {/* First Name */}
                {/* <FormGroup as={Row} className="mb-2">
                  <FormLabel column sm="3">
                    Case Type: <span className="required-aes">*</span>
                  </FormLabel>
                  <Col sm="6">
                    <FormLabel column sm="3" style={{ fontWeight: "bold" }}>
                      {selectedOption.case_type?.name || "N/A"}
                    </FormLabel>
                  </Col>
                </FormGroup> */}

                {/* Age */}
                {/* <FormGroup as={Row} className="mb-2">
                  <FormLabel column sm="3">
                    Incident Date: <span className="required-aes">*</span>
                  </FormLabel>
                  <Col sm="6">
                    <FormLabel column sm="3" style={{ fontWeight: "bold" }}>
                      {formatCalendarDate(selectedOption.incident_date) || "N/A"}
                    </FormLabel>
                  </Col>
                </FormGroup> */}
              </Col>
            )}
            <div className="text-end d-flex align-items-center m-t-5 justify-content-end">
              <Button
                variant="primary"
                onClick={() => handleTabChange("client")}
                className="height-25 d-flex align-items-center justify-content-center"
              >
                Next
              </Button>
            </div>
          </>
        ))}
      {activeTab === "notes" && (
        <>
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Notes Information
          </span>
          <Col sm="12" className="ps-0 p-r-5 m-t-5">
            <FormGroup>
              <FormControl
                as="textarea"
                placeholder="Enter Intake Notes"
                value={data.notes || ""}
                onChange={(e) => onChange("notes", e.target.value)}
                style={{
                  resize: "none",
                  height: "140px",
                }}
              />
            </FormGroup>
          </Col>
          <div className="text-end m-t-5 d-flex align-items-center justify-content-end">
            <Button
              variant="success"
              onClick={() => handleSave()}
              className="height-25 d-flex align-items-center justify-content-center"
              disabled={loadingSave}
              aria-busy={loadingSave}
            >
              {loadingSave ? "Saving..." : "Save"}
            </Button>
          </div>
        </>
      )}
      {/* {activeTab === "notes" && (
        <Col
          md="9"
          className="tabclient"
          style={{ paddingLeft: "0px", marginLeft: "0px", marginTop: "5px" }}
        >
          <FormGroup as={Row} className="mb-2">
            <Col sm="5">
              <FormControl
                as="textarea"
                placeholder="Enter Intake Notes"
                value={data.notes || ""}
                onChange={(e) => onChange("notes", e.target.value)}
              />
            </Col>
          </FormGroup>
        </Col>
      )} */}

      {/* Client */}

      {activeTab === "client" && (
        <>
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Client Information
          </span>
          {selectedOption && (
            <Row className="mx-auto m-b-5 m-t-5">
              <Col sm="12" className="ps-0 p-r-5">
                <FormGroup>
                  <div ref={addressDropdownRef} className="custom-select-new-provider">
                    <div
                      className={`dropdown-button rounded-0 height-25 p-l-5 form-control d-flex align-items-center ${
                        selectedCaseAddress ? "has-value" : ""
                      }`}
                      role="button"
                      tabIndex={addressesLoading || caseClientAddresses.length === 0 ? -1 : 0}
                      aria-haspopup="listbox"
                      aria-expanded={addressDropdownOpen}
                      aria-disabled={addressesLoading || caseClientAddresses.length === 0}
                      onClick={() => {
                        if (!addressesLoading && caseClientAddresses.length > 0) {
                          setAddressDropdownOpen((isOpen) => !isOpen);
                        }
                      }}
                      onKeyDown={(event) => {
                        if (
                          (event.key === "Enter" || event.key === " ") &&
                          !addressesLoading &&
                          caseClientAddresses.length > 0
                        ) {
                          event.preventDefault();
                          setAddressDropdownOpen((isOpen) => !isOpen);
                        }
                      }}
                      style={{
                        paddingRight: "35px",
                        cursor:
                          addressesLoading || caseClientAddresses.length === 0
                            ? "default"
                            : "pointer",
                      }}
                    >
                      <span className="text-truncate">
                        {addressesLoading
                          ? "Loading addresses from the selected case..."
                          : selectedCaseAddress
                            ? `${selectedCaseAddress.client_name || "Client"} — ${
                                formatCaseClientAddress(selectedCaseAddress) ||
                                "No address details available"
                              }`
                            : caseClientAddresses.length > 0
                              ? "Select an existing client address"
                              : "No client addresses are available for this case"}
                      </span>
                    </div>

                    {addressDropdownOpen && caseClientAddresses.length > 0 && (
                      <div
                        className="dropdown-menu p-0 mt-0"
                        role="listbox"
                        style={{
                          display: "block",
                          width: "100%",
                          border: "1px solid #ced4da",
                          maxHeight: "220px",
                          minHeight: "220px",
                          overflowY: "auto",
                          zIndex: 9999,
                        }}
                      >
                        {caseClientAddresses.map((address, index) => (
                          <div
                            key={`${address.client_id || "client"}-${index}`}
                            className="dropdown-option"
                            role="option"
                            aria-selected={selectedCaseAddress === address}
                            tabIndex={0}
                            onClick={() => handleCaseAddressSelect(address)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                handleCaseAddressSelect(address);
                              }
                            }}
                            style={{
                              cursor: "pointer",
                              paddingLeft: "5px",
                              borderBottom:
                                index < caseClientAddresses.length - 1
                                  ? "1px solid #e9ecef"
                                  : "none",
                            }}
                          >
                            <div
                              className="height-25 d-flex align-items-center"
                              style={{ fontSize: "14px", color: "black" }}
                            >
                              {formatCaseClientAddress(address) || "No address details available"}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          )}
          <Row className="mx-auto m-b-5 m-t-5">
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Client First Name"
                  value={data.client_first_name || ""}
                  onChange={(e) => onChange("client_first_name", e.target.value)}
                  // className="haddress2 form-control"
                  className={`form-control height-25 p-0 p-l-5 ${
                    clientNameValidationAttempted && !data.client_first_name?.trim()
                      ? "is-invalid"
                      : ""
                  }`}
                  aria-invalid={clientNameValidationAttempted && !data.client_first_name?.trim()}
                />
              </FormGroup>
            </Col>
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Client Middle Name"
                  value={data.client_middle_name || ""}
                  onChange={(e) => onChange("client_middle_name", e.target.value)}
                  className="form-control height-25 p-0 p-l-5"
                />
              </FormGroup>
            </Col>
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Client Last Name"
                  value={data.client_last_name || ""}
                  onChange={(e) => onChange("client_last_name", e.target.value)}
                  className={`form-control height-25 p-0 p-l-5 ${
                    clientNameValidationAttempted && !data.client_last_name?.trim()
                      ? "is-invalid"
                      : ""
                  }`}
                  aria-invalid={clientNameValidationAttempted && !data.client_last_name?.trim()}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mx-auto m-b-5">
            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <DateInput
                  placeholder="Enter New Client DOB"
                  value={data.client_dob || ""}
                  onChange={(e) => onChange("client_dob", e.target.value)}
                  // className="haddress2"
                  // className={getFieldClass(data.client_dob, true)}
                  className="form-control height-25 p-0 p-l-5"
                />
              </FormGroup>
            </Col>

            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  className="form-control height-25 p-l-5 p-0"
                  placeholder="Enter New Client Address 1"
                  value={data.client_address1 || ""}
                  onChange={(e) => onChange("client_address1", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Client Address 2"
                  value={data.client_address2 || ""}
                  className="form-control height-25 p-l-5 p-0"
                  onChange={(e) => onChange("client_address2", e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mx-auto m-b-5">
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="City"
                  className="form-control height-25 p-l-5 p-0"
                  value={data.client_city || ""}
                  onChange={(e) => onChange("client_city", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm="2" style={{ paddingLeft: "0px", paddingRight: "5px" }}>
              <FormGroup>
                <div className="tabclient custom-select-new-provider">
                  <div
                    className={`dropdown-button rounded-0 height-25 p-l-5 form-control d-flex align-items-center ${
                      homeStateClient ? "has-value" : ""
                    }`}
                    onClick={() => setShowStatesModalClientThird(true)}
                  >
                    <span id="selectedOption">
                      {homeStateClient ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${homeStateClient.StateAbr}`}
                          >
                            <use xlinkHref={`#icon-state-${homeStateClient.StateAbr}`} />
                          </svg>
                          <span className="m-l-5">{homeStateClient.StateAbr}</span>
                        </div>
                      ) : (
                        "State"
                      )}
                    </span>
                  </div>
                </div>
              </FormGroup>
            </Col>
            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="ZIP"
                  className="form-control height-25 p-l-5 p-0"
                  value={data.client_zip || ""}
                  onChange={(e) => onChange("client_zip", e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Client Phone"
                  value={data.client_phone || ""}
                  onChange={handleClientPhoneChange}
                  className="form-control height-25 p-l-5 p-0"
                />
                {/* {!isPhoneValid.client_phone && (
                          <>
                            <OverlayTrigger placement="right" overlay={tooltipphone}>
                              <ErrorOutlineIcon
                                style={{
                                  marginRight: "-25px",
                                  position: "relative",
                                  left: "10px",
                                  top: "5px",
                                }}
                              />
                            </OverlayTrigger>
                          </>
                        )}
                      */}
              </FormGroup>
            </Col>
            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="email"
                  placeholder="Enter New Client Email"
                  value={data.client_email || ""}
                  onChange={handleClientEmailChange}
                  className="form-control height-25 p-l-5 p-0"
                />
                {/* {!isEmailValid.client_email && (
                          <>
                            <OverlayTrigger placement="right" overlay={tooltip}>
                              <ErrorOutlineIcon
                                style={{
                                  marginRight: "-25px",
                                  position: "relative",
                                  left: "10px",
                                  top: "5px",
                                }}
                              />
                            </OverlayTrigger>
                          </>
                        )} */}
              </FormGroup>
            </Col>
          </Row>

          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Insurance Information
          </span>
          <Row className="mx-auto m-t-5 mb-0">
            <div
              ref={insuranceTypeRef}
              className="col-md-3 ps-0 p-r-5 custom-select-new-provider"
              style={{ position: "relative" }}
            >
              <div
                className={`dropdown-button form-control p-0 p-l-5 rounded-0 height-25 d-flex align-items-center ${getFieldClass(
                  data.client_insurance_type,
                  false
                )}`}
                onClick={() => setInsuranceTypeOpen((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <span>
                  {data.client_insurance_type
                    ? insuranceNewTypes?.find((t) => t.id === data.client_insurance_type)?.name
                    : "Select New Client Insurance Type"}
                </span>
              </div>

              {insuranceTypeOpen && (
                <div
                  className="dropdown-menu p-0 mt-0"
                  style={{
                    width: "99%",
                    border: "1px solid #ced4da",
                    maxHeight: "200px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  <div
                    className="dropdown-option height-25 d-flex align-items-center"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => {
                      onChange("client_insurance_type", 0);
                      setInsuranceTypeOpen(false);
                    }}
                  >
                    Select New Client Insurance Type
                  </div>

                  {insuranceNewTypes?.map((type) => (
                    <div
                      key={type.id}
                      className="dropdown-option height-25 d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        paddingLeft: "5px",
                        fontWeight: "600",
                      }}
                      onClick={() => {
                        onChange("client_insurance_type", type.id);
                        setInsuranceTypeOpen(false);
                      }}
                    >
                      {type.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Col sm="3" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  className="form-control height-25 p-l-5 p-0"
                  placeholder="Enter New Client Policy #"
                  value={data.client_policy_number || ""}
                  onChange={(e) => onChange("client_policy_number", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm="3" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Client Claim #"
                  className="form-control height-25 p-l-5 p-0"
                  value={data.client_claim_number || ""}
                  onChange={(e) => onChange("client_claim_number", e.target.value)}
                />
              </FormGroup>
            </Col>

            {fieldStates.jurisdiction && (
              <Col sm="3" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter Jurisdiction"
                    value={data.intake_jurisdiction || ""}
                    onChange={(e) => onChange("intake_jurisdiction", e.target.value)}
                    // className="haddress2"
                    className="form-control height-25 p-l-5 p-0"
                  />
                </FormGroup>
              </Col>
            )}
          </Row>

          <Row className="mx-0">
            <Col ref={companySearchRef} md={12} className="ps-0 p-r-5">
              <Form.Control
                type="text"
                name="search_filter_insurance_input"
                value={companySearchInput}
                placeholder="Type Insurance Company name to search directory then click an entry"
                className="custom-margin-top custom-margin-bottom height-25 p-0 p-l-5 rounded-0"
                onChange={(e) => {
                  setCompanySearchInput(e.target.value);
                  handleSearchInsurances(e, "company");
                }}
              />
              {companySearchInput && (
                <span
                  onClick={() => {
                    setCompanySearchInput("");
                    handleSearchInsurances({ target: { value: "" } }, "company");
                    onChange("client_insurance_company_id", "");

                    onChange("client_company_name", "");
                    onChange("client_company_address1", "");
                    onChange("client_company_address2", "");
                    onChange("client_company_city", "");
                    onChange("client_company_state", "");
                    onChange("client_company_zip", "");
                    onChange("client_company_phone", "");
                    onChange("client_company_extension_field", "");
                    onChange("client_company_fax", "");
                    onChange("client_company_email", "");
                    onChange("client_company_website", "");
                  }}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "black",
                    lineHeight: 1,
                    userSelect: "none",
                  }}
                >
                  ✕
                </span>
              )}
              {searchedInsurances.length > 0 && (
                <AutoCompleteSearch
                  searchedInsurances={searchedInsurances}
                  selectedInsurance={(data) => handleSelectedInsuranceTabs("company", data)}
                  isCompany={true}
                />
              )}
            </Col>
          </Row>
          <Row className="mx-0 p-l-5">
            <ContactPanelForEditPopups
              panel_name={"Insurance Company"}
              className="m-b-5"
              dynamic_label={"Company Name"}
              name={data?.client_company_name}
              address1={data?.client_company_address1}
              address2={data?.client_company_address2}
              email={data?.client_company_email}
              phone_number={data?.client_company_phone}
              city={data?.client_company_city}
              state={data?.client_company_state}
              zip_code={data?.client_company_zip}
              fax_number={data?.client_company_fax}
              ext={data?.client_company_extension_field}
              websiteURL={data?.client_company_website}
              buttonData={InsuranceButtons}
              pageName="Case Loans"
            />

            <Col md={"auto"} className="p-0 d-flex-1">
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Name"
                  value={data?.client_company_name || ""}
                  onChange={(e) => onChange("client_company_name", e.target.value)}
                />
              </div>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 1"
                    value={data?.client_company_address1 || ""}
                    onChange={(e) => onChange("client_company_address1", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 2"
                    value={data?.client_company_address2 || ""}
                    onChange={(e) => onChange("client_company_address2", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="City"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_company_city || ""}
                    onChange={(e) => onChange("client_company_city", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                  <div
                    className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                    onClick={handleStateShow}
                  >
                    <span id="selectedOption">
                      {data?.client_company_state ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${data?.client_company_state}`}
                          >
                            <use xlinkHref={`#icon-state-${data?.client_company_state}`} />
                          </svg>
                          {data?.client_company_state}
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex-1 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Zip"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_company_zip || ""}
                    onChange={(e) => onChange("client_company_zip", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-####"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_company_phone || ""}
                    onChange={(e) => handlePhoneChange(e)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Extension"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_company_extension_field || ""}
                    onChange={(e) => onChange("client_company_extension_field", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-#### - fax"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_company_fax || ""}
                    onChange={(e) => handleFaxChange(e)}
                  />
                </div>
              </Row>
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Email"
                  value={data?.client_company_email || ""}
                  onChange={(e) => onChange("client_company_email", e.target.value)}
                />
              </div>

              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Website"
                  value={data?.client_company_website || ""}
                  onChange={(e) => onChange("client_company_website", e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row className="mx-0">
            <Col ref={adjusterSearchRef} md={12} className="ps-0 p-r-5">
              <Form.Control
                type="text"
                name="search_filter_adjuster_input"
                value={adjusterSearchInput}
                placeholder="Type Insurance Adjuster name to search directory then click an entry"
                className="custom-margin-top custom-margin-bottom  mt-0 height-25 p-0 p-l-5 rounded-0"
                onChange={(e) => {
                  setAdjusterSearchInput(e.target.value);
                  handleSearchInsurances(e, "adjuster");
                }}
              />
              {adjusterSearchInput && (
                <span
                  onClick={() => {
                    setAdjusterSearchInput("");
                    handleSearchInsurances({ target: { value: "" } }, "adjuster");
                    onChange("client_insurance_adjuster_id", "");
                    onChange("client_adjuster_first_name", "");
                    onChange("client_adjuster_last_name", "");
                    onChange("client_adjuster_address1", "");
                    onChange("client_adjuster_address2", "");
                    onChange("client_adjuster_city", "");
                    onChange("client_adjuster_state", "");
                    onChange("client_adjuster_zip", "");
                    onChange("client_adjuster_phone", "");
                    onChange("client_adjuster_extension_field", "");
                    onChange("client_adjuster_fax", "");
                    onChange("client_adjuster_email", "");
                    onChange("client_adjuster_website", "");
                  }}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "black",
                    lineHeight: 1,
                    userSelect: "none",
                  }}
                >
                  ✕
                </span>
              )}
              {searchedAjusters.length > 0 && (
                <AutoCompleteSearch
                  searchedInsurances={searchedAjusters}
                  selectedInsurance={(data) => handleSelectedInsuranceTabs("adjuster", data)}
                  isAdjuster={true}
                />
              )}
            </Col>
          </Row>
          <Row className="mx-0 p-l-5">
            <div style={{ width: "260px" }}>
              <ContactPanelForEditPopups
                panel_name={"Adjuster"}
                className="m-b-5"
                name={`${data?.client_adjuster_first_name || ""} ${data?.client_adjuster_last_name || ""}`}
                address1={data?.client_adjuster_address1}
                address2={data?.client_adjuster_address2}
                email={data?.client_adjuster_email}
                phone_number={data?.client_adjuster_phone}
                city={data?.client_adjuster_city}
                state={data?.client_adjuster_state}
                zip_code={data?.client_adjuster_zip}
                fax_number={data?.client_adjuster_fax}
                ext={data?.client_adjuster_extension_field}
                websiteURL={data?.client_adjuster_website}
                buttonData={InsuranceButtons}
                pageName="Case Loans"
              />
            </div>
            <Col md={"auto"} className="p-0 d-flex-1">
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "5px",
                  }}
                >
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Adjuster First Name"
                    value={data?.client_adjuster_first_name || ""}
                    onChange={(e) => onChange("client_adjuster_first_name", e.target.value)}
                  />
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Adjuster Last Name"
                    value={data?.client_adjuster_last_name || ""}
                    onChange={(e) => onChange("client_adjuster_last_name", e.target.value)}
                  />
                </div>
              </div>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 1"
                    value={data?.client_adjuster_address1 || ""}
                    onChange={(e) => onChange("client_adjuster_address1", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 2"
                    value={data?.client_adjuster_address2 || ""}
                    onChange={(e) => onChange("client_adjuster_address2", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="City"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_adjuster_city || ""}
                    onChange={(e) => onChange("client_adjuster_city", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                  <div
                    className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                    onClick={handleAdjusterStateShow}
                  >
                    <span id="selectedOption">
                      {data?.client_adjuster_state ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${data?.client_adjuster_state}`}
                          >
                            <use xlinkHref={`#icon-state-${data?.client_adjuster_state}`} />
                          </svg>
                          {data?.client_adjuster_state}
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex-1 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Zip"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_adjuster_zip || ""}
                    onChange={(e) => onChange("client_adjuster_zip", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-####"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_adjuster_phone || ""}
                    onChange={(e) => handlePhoneChangeAdj(e)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Extension"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_adjuster_extension_field || ""}
                    onChange={(e) => onChange("client_adjuster_extension_field", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-#### - fax"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.client_adjuster_fax || ""}
                    onChange={(e) => handleFaxChangeAdj(e)}
                  />
                </div>
              </Row>
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Email"
                  value={data?.client_adjuster_email || ""}
                  onChange={(e) => onChange("client_adjuster_email", e.target.value)}
                />
              </div>

              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Website"
                  value={data?.client_adjuster_website || ""}
                  onChange={(e) => onChange("client_adjuster_website", e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <div className="text-end d-flex align-items-center justify-content-end">
            <Button
              variant="primary"
              onClick={() => handleTabChange("source")}
              className="height-25 d-flex align-items-center justify-content-center"
            >
              Next
            </Button>
          </div>
        </>
      )}

      {activeTab === "source" && (
        <>
          {/* <h5 style={{ fontSize: "17px" }}>Source</h5> */}
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Source Information
          </span>
          <Row className="mx-auto m-b-5 m-t-5">
            <Col sm="12" className="ps-0 pe-0">
              <FormGroup style={{ position: "relative", marginBottom: 0 }}>
                <FormControl
                  type="text"
                  placeholder="Search sources…"
                  value={search2}
                  onChange={(e) => setSearch2(e.target.value)}
                  className="form-control height-25 p-0 p-l-5"
                />

                {/* Search results — clicking one pre-fills the 3 dropdowns below */}
                {search2?.trim() !== "" && (
                  <div
                    style={{
                      position: "absolute",
                      top: "25px",
                      left: 0,
                      right: 0,
                      background: "white",
                      border: "1px solid #ced4da",
                      borderTop: "none",
                      maxHeight: "180px",
                      overflowY: "auto",
                      scrollbarWidth: "none",
                      zIndex: 200,
                      boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                    }}
                  >
                    {sourceSearchLoading ? (
                      <div style={{ padding: "5px 8px", fontSize: "12px", color: "#999" }}>
                        Searching…
                      </div>
                    ) : searchedSources.length === 0 ? (
                      <div style={{ padding: "5px 8px", fontSize: "12px", color: "#999" }}>
                        No sources found
                      </div>
                    ) : (
                      searchedSources.map((source) => (
                        <div
                          key={source.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: "32px",
                            padding: "0 10px",
                            gap: "8px",
                            cursor: "pointer",
                            background: "transparent",
                            borderBottom: "0.5px solid var(--color-border-tertiary)",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "var(--color-background-secondary)")
                          }
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          onClick={() => {
                            handleTypeChange({ target: { value: source.source_type } });
                            handleCategoryChange({
                              target: { value: source.source_category ?? 0 },
                            });
                            handleSourceNameChange({ target: { value: source.id } });
                            setSearch2("");
                          }}
                        >
                          {/* Type + Category breadcrumb */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              flexShrink: 0,
                            }}
                          >
                            {source.source_type_name && (
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  background: "var(--primary-10)",
                                  color: "var(--primary)",
                                  borderRadius: "4px",
                                  padding: "1px 6px",
                                  whiteSpace: "nowrap",
                                  lineHeight: "14px",
                                }}
                              >
                                {source.source_type_name}
                              </span>
                            )}
                            {source.source_category_name && (
                              <>
                                <span
                                  style={{ fontSize: "11px", color: "var(--color-text-tertiary)" }}
                                >
                                  ›
                                </span>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {source.source_category_name}
                                </span>
                              </>
                            )}
                          </div>

                          {/* Divider */}
                          <span
                            style={{
                              width: "0.5px",
                              height: "19px",
                              background: "var(--primary-50)",
                              flexShrink: 0,
                            }}
                          />

                          {/* Source name */}
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "var(--primary)",
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {source.name}
                          </span>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <SourceLinking
            ref={sourceLinkingRef} // ← add this
            setShowStatesModalSource={setLinkModal}
            sourceTypes={sourceTypes}
            filteredCategories={filteredCategories}
            filteredCaseSources={filteredCaseSources}
            selectedType={selectedType}
            selectedCategory={selectedCategory}
            selectedSourceName={selectedSourceName}
            handleTypeChange={handleTypeChange}
            handleCategoryChange={handleCategoryChange}
            handleSourceNameChange={handleSourceNameChange}
            disabledCategory={disabledCategory}
            disabledSourceName={disabledSourceName}
            getFieldClass={getFieldClass}
            sourceTypeOpen={sourceTypeOpen}
            setSourceTypeOpen={setSourceTypeOpen}
            sourceCategoryOpen={sourceCategoryOpen}
            setSourceCategoryOpen={setSourceCategoryOpen}
            sourceNameOpen={sourceNameOpen}
            setSourceNameOpen={setSourceNameOpen}
            linkedSources={linkedSources}
            onLinkedChange={setLinkedSources}
            onOpenStateModal={(key) => {
              setPendingSourceStateKey(key);
              setLinkModal(true);
            }}
          />

          {linkModal && (
            <SelectStateModal
              show={linkModal}
              handleClose={() => setLinkModal(false)}
              onChange={(selected) => {
                if (pendingSourceStateKey) {
                  // update that specific linked source's state
                  setLinkedSources((prev) =>
                    prev.map((l) =>
                      l._key === pendingSourceStateKey
                        ? { ...l, metadata: { ...l.metadata, source_state: selected?.StateAbr } }
                        : l
                    )
                  );
                  setPendingSourceStateKey(null);
                } else {
                  // old behavior — main source state field
                  // setHomeStateSource(selected);
                  // onChange("source_state", selected?.StateAbr);
                }
                setLinkModal(false);
              }}
              statesData={state}
            />
          )}
          <div className="text-end d-flex align-items-center justify-content-end">
            <Button
              variant="primary"
              onClick={() => handleTabChange("notes")}
              className="height-25 d-flex align-items-center justify-content-center"
            >
              Next
            </Button>
          </div>
        </>
      )}

      {showStatesModalClientThird && (
        <SelectStateModal
          show={showStatesModalClientThird}
          handleClose={() => setShowStatesModalClientThird(false)}
          onChange={(selected) => {
            setHomeStateClient(selected);
            onChange("client_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}
      {insuranceNewCompanyState && (
        <SelectStateModal
          show={insuranceNewCompanyState}
          handleClose={() => setInsuranceNewCompanyState(false)}
          onChange={(selected) => {
            onChange("client_company_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {adjusterState && (
        <SelectStateModal
          show={adjusterState}
          handleClose={() => setAdjusterState(false)}
          onChange={(selected) => {
            onChange("client_adjuster_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}
      {showStatesModalSourceThird && (
        <SelectStateModal
          show={showStatesModalSourceThird}
          handleClose={() => setShowStatesModalSourceThird(false)}
          onChange={(selected) => {
            setHomeStateSource(selected);
            onChange("source_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}
    </>
  );
};

export default NewClientForExistingCase;
